import React, { useEffect, useMemo } from 'react';
import { Space, Tooltip } from 'antd';
import humanizeUtil from '@utils/humanizeUtil';
import { isAppModule } from '@utils/constants';
import { WarningOutlined } from '@ant-design/icons';
import { formatGaugeChartData } from '../../utils/spi';
import {
  SPIWidgetWrapper,
  WidgetNumberWrapper,
  WidgetTextWrapper,
  SPIScoreWrapper,
  TitleContainer,
  MetricTitle,
} from './styled';

import { SPI_METRIC, THRESHOLD_SERVICE_STATUS_TEXT } from '@utils/kpi/spi';
import BaseChart, { useChartInstance } from '@src/components/common/BaseChart';
import { getTextColor } from '@src/utils/kpi/tools';
import useSelectMetric from '../../hooks/useSelectMetric';
import { EllipsisTooltip } from '@src/components/common';

const SPIGauge = ({ data = {}, currentKpi }) => {
  let isThresholdServiceDown = false;
  if (currentKpi === '') {
    isThresholdServiceDown = true;
  }
  const metricKey = SPI_METRIC;
  const spiScore = data[metricKey];
  const spiColor = getTextColor(spiScore || 0);
  const kpiName = `${isThresholdServiceDown ? 'Conviva Good' : currentKpi?.kpiName}`;
  const { instance, chartInstanceRefCb } = useChartInstance({});

  const chartOption = useMemo(() => {
    const { humanizedNumber } = humanizeUtil(spiScore, metricKey);
    return formatGaugeChartData(humanizedNumber);
  }, [spiScore]);

  const selectMetric = useSelectMetric();

  const handleClick = () => {
    selectMetric(metricKey);
  };

  useEffect(() => {
    if (instance) {
      instance.setOption(chartOption);
    }
  }, [instance, chartOption]);

  return (
    <SPIWidgetWrapper onClick={handleClick}>
      <WidgetTextWrapper style={{ marginRight: '10px', width: 'max-content' }}>
        <TitleContainer>
          <MetricTitle>
            <EllipsisTooltip text={kpiName} />
          </MetricTitle>
          {isThresholdServiceDown ? (
            <Tooltip title={THRESHOLD_SERVICE_STATUS_TEXT}>
              <WarningOutlined style={{ color: 'grey' }} />
            </Tooltip>
          ) : null}
        </TitleContainer>
      </WidgetTextWrapper>
      <Space>
        <BaseChart chartInstanceRefCb={chartInstanceRefCb} style={{ height: 50, width: 50 }} />
        <SPIScoreWrapper isSettingsPresent={isAppModule}>
          <WidgetNumberWrapper style={{ color: spiColor }}>
            {humanizeUtil(spiScore, metricKey).humanizedNumber}
          </WidgetNumberWrapper>
        </SPIScoreWrapper>
      </Space>
    </SPIWidgetWrapper>
  );
};

export default SPIGauge;
